import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PAGE_NAME } from '../../../../utils/constants';
import s from './NavigationHeader.module.scss';

interface NavigationHeaderProps {
    modelName: string;
}

export const NavigationHeader: React.FC<NavigationHeaderProps> = ({
    modelName,
}) => {
    const navigate = useNavigate();

    return (
        <div className={s.nav}>
            <button className={s.nav_back} onClick={() => navigate(PAGE_NAME.home)}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                        d="M10 12L6 8L10 4"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
                All Models
            </button>
            <div className={s.nav_model}>{modelName}</div>
        </div>
    );
};
